import classNames from 'classnames';
import dateFormat from 'dateformat';
import React from 'react';
import { UtilizationType } from 'types/debt-types';
import classes from './index.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data: UtilizationType[];
}

const UtilizationGraphLabels = ({ data, className }: Props) => {
  const labels = data.map(({ date }) =>
    dateFormat(new Date(date).toUTC(), 'mmm')
  );

  const filteredLabels = labels.filter((_, index) => index % 2 === 0);

  return (
    <div className={classNames(classes.container, className)}>
      {filteredLabels.map((label, index) => (
        <div
          className={classes.label}
          key={index.toString()}
        >
          {label.toUpperCase()}
        </div>
      ))}
    </div>
  );
};
export default UtilizationGraphLabels;
